import { AirWeightBracketPriceMapper } from "./air-weight-bracket-price.mapper";
import { AirWeightBracketPriceDict } from "./air-weight-bracket-price-dict.type";
import { AirWeightBracketPrice } from "./air-weight-bracket-price.model";

export class AirWeightBracketPriceDictMapper {
  public static toDict(data: any = []): AirWeightBracketPriceDict {
    const containers = <AirWeightBracketPriceDict>{};

    if (Array.isArray(data)) {
      data.forEach((containerObject) => {
        containers[containerObject.name] =
          AirWeightBracketPriceMapper.map(containerObject);
      });
    }

    return containers;
  }

  public static toArray(
    data: AirWeightBracketPriceDict,
  ): AirWeightBracketPrice[] {
    return Object.keys(data).map(
      (weightBracketName) =>
        new AirWeightBracketPrice(
          weightBracketName,
          data[weightBracketName].value,
        ),
    );
  }
}
